import { Platform } from "react-native"

/**
 * Sur le web, react-native-web n'active à la barre d'espace que le rôle
 * « button » : un bouton radio, un interrupteur ou un onglet l'attendent
 * pourtant aussi. À étaler sur le `Pressable` qui porte ce rôle.
 */
export const pressOnSpace = (onPress) =>
    Platform.OS === "web"
        ? {
              onKeyDown: (event) => {
                  if (event.key !== " ") return
                  event.preventDefault()
                  onPress?.()
              },
          }
        : null
